var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { noop } from 'utils/functions';
const Icon = forwardRef((_a, ref) => {
    var { name, fill, stroke, strokeWidth, transform } = _a, rest = __rest(_a, ["name", "fill", "stroke", "strokeWidth", "transform"]);
    return (React.createElement("svg", Object.assign({ ref: ref, className: "icon", "data-name": "icon" }, rest),
        React.createElement("use", { xlinkHref: `#${name}`, fill: fill, stroke: stroke, strokeWidth: strokeWidth, transform: transform })));
});
Icon.displayName = 'Icon';
Icon.defaultProps = {
    onClick: noop,
};
export default Icon;
